export default () => {
    let $timerView = $('.countdown-timer__hours');

    let endDate = $('.countdown-timer').data("end-date");

    function diffSubtract(date1, date2) {
        return date2 - date1;
    }

    let timer = setInterval(function () {
        let now = new Date();
        let date = new Date(endDate);
        let msLeft = diffSubtract(now, date);
        if (msLeft <= 0) {
            clearInterval(timer);
        } else {
            let res = new Date(msLeft);
            const formatedSec = ('0' + res.getUTCSeconds()).slice(-2);
            const formatedMins = ('0' + res.getUTCMinutes()).slice(-2);
            const formatedHours = ('0' + res.getUTCHours()).slice(-2);
            let strTimer = `${formatedHours}:${formatedMins}:${formatedSec}`;
            $timerView.html(strTimer);
        }
    }, 1000)
}


// WEBPACK FOOTER //
// ./resources/assets/js/blocks/countdown-timer/index.js